export default "__VITE_ASSET__jchAO1nt__"